import { render, staticRenderFns } from "./accumulatorList.vue?vue&type=template&id=215ca0de&scoped=true&lang=html"
import script from "./accumulatorList.vue?vue&type=script&lang=js"
export * from "./accumulatorList.vue?vue&type=script&lang=js"
import style0 from "./accumulatorList.vue?vue&type=style&index=0&id=215ca0de&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215ca0de",
  null
  
)

export default component.exports